import React from 'react'

// Button component with multiple variants and loading state

const Button = ({ children, variant = 'primary', size = 'md', loading, disabled, onClick, type = 'button', className }) => {
    const baseClass = 'font-medium transition flex items-center gap-2 justify-center';
    const sizeClass = {
        xs: 'px-1.5 py-1 text-xs',
        sm: 'px-3 py-1.5 text-sm',
        md: 'px-4 py-2 text-base',
        lg: 'px-6 py-3 text-lg'
    }[size];

    const variantClass = {
        primary: 'bg-white dark:bg-gray-800 border border-blue-500 hover:border-blue-600 text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300 dark:border-blue-400 disabled:border-gray-400 disabled:text-gray-400',
        secondary: 'bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 text-gray-900 dark:text-gray-100',
        danger: 'bg-white dark:bg-gray-800 border border-red-500 hover:border-red-600 text-red-500 hover:text-red-600 dark:text-red-400 dark:hover:text-red-300 dark:border-red-400 disabled:border-gray-400 disabled:text-gray-400',
        warning: 'bg-white dark:bg-gray-800 border border-amber-500 hover:border-amber-600 text-amber-500 hover:text-amber-600 dark:text-amber-400 dark:hover:text-amber-300 dark:border-amber-400 disabled:border-gray-400 disabled:text-gray-400',
        success: 'bg-white dark:bg-gray-800 border border-green-500 hover:border-green-600 text-green-500 hover:text-green-600 dark:text-green-400 dark:hover:text-green-300 dark:border-green-400 disabled:border-gray-400 disabled:text-gray-400',
        ghost: 'hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-900 dark:text-gray-100'
    }[variant];

    const spinnerIcon = (
        <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" className="opacity-25" />
            <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" className="opacity-75" />
        </svg>
    );

    return (
        <button
            type={type}
            onClick={onClick}
            className={`${baseClass} ${sizeClass} ${variantClass} disabled:cursor-not-allowed ${className || ''}`}
            disabled={disabled || loading}
        >
            {loading && spinnerIcon}
            {children}
        </button>
    );
};

export default Button
